import React from 'react';
import { cn } from '@/lib/utils';
import starts from '@/imgs/starts.png';
interface SummaryProps {
  title?: string;
  icon?: string;
  iconAlt?: string;
  content?: string;
  suggestions?: string[];
  className?: string;
  isShowSuggestions?: boolean;
  children?: React.ReactNode;
}

const Summary: React.FC<SummaryProps> = ({
  title = 'AI智能诊断总结',
  icon = starts,
  iconAlt = 'AI诊断',
  content = '暂无内容',
  suggestions = ['暂无建议'],
  isShowSuggestions = true,
  className = '',
  children
}) => {
  return (
    <div className={cn('relative rounded-lg bg-white p-[2px]', className)}>
      {/* 渐变边框效果 */}
      <div className={cn('gradient-border-box absolute inset-0 p-[1px]', className)}>
        <div className="h-full w-full rounded-lg bg-white"></div>
      </div>

      {/* AI智能诊断总结卡片 */}
      <div className="relative z-10 rounded-lg bg-gradient-to-l from-[#F7FAFF] to-[#FFFCFC] p-3">
        {title && (
          <div className="mb-2 flex items-center gap-1">
            <div className="h-6 w-6">
              <img src={icon} className="h-full w-full object-cover" alt={iconAlt} />
            </div>
            <span className="text-base font-semibold text-[#1F1F1F]">{title}</span>
          </div>
        )}
        {children ? (
          children
        ) : (
          <>
            {content && (
              <p className="mb-3 text-left text-xs leading-[20px] text-[#1F1F1F]">{content}</p>
            )}

            {/* 建议标题 */}
            {isShowSuggestions && (
              <div className="mb-2 flex items-center gap-1">
                <span className="text-sm font-semibold text-[#1F1F1F]">建议</span>
              </div>
            )}

            {/* 建议内容 */}
            {isShowSuggestions && (
              <div className="rounded-md p-2">
                <p className="text-left text-xs leading-relaxed text-[#1F1F1F]">
                  {suggestions.map((suggestion, index) => (
                    <React.Fragment key={index}>
                      <span className="mr-1 text-xs text-[#1F1F1F]">•</span> {suggestion}
                      {index < suggestions.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Summary;
